var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"full-calendar-app"},[_c('full-calendar',{attrs:{"events":_vm.events,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }